import { useCallback } from "react";
import { Icons } from "../../../Everou/_assets";
import { CapsuleButton } from "../../../Everou/_components";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useGlobalNotification } from "../../../Common/_hooks/useGlobalNotification";

type ReservationPublicUrlProps = {
    publicUrl: string;
    compact?: boolean;
};

export function ReservationPublicUrl({
    publicUrl,
    compact = false,
}: ReservationPublicUrlProps) {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { notify } = useGlobalNotification();


    const handleCopyToClipboard = useCallback(() => {
        navigator.clipboard.writeText(publicUrl);
        notify(t("global_copied"), "success");
    }, [publicUrl, notify, t]);


    //VIEW
    const link = (
        <small
            style={compact ? { minWidth: 0, maxWidth: '180px' } : { maxWidth: '300px' }}
            className={compact ? "c-line-height-1" : "mr-2 w-75 c-line-height-1"}
        >
            {publicUrl ? (
                <a
                    className="d-block w-100 text-secondary"
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                    rel="noreferrer"
                    href={publicUrl}
                    target="_blank"
                >
                    {publicUrl}
                </a>
            ) : (
                t("invitation_link_generate_info")
            )}
        </small>
    );

    if (compact) {
        return (
            <div
                className="d-flex align-items-center mt-1 position-relative"
                style={{ padding: "1px 4px", columnGap: "8px" }}
            >
                <img
                    src={Icons.invitations}
                    alt=""
                    style={{ width: "14px", height: "14px", opacity: 0.45, flexShrink: 0 }}
                />
                <span
                    className="text-secondary c-text-capitalize-first c-line-height-1"
                    style={{ whiteSpace: "nowrap" }}
                >
                    {t("invitation_public_url")}
                </span>
                {publicUrl ? (
                    <a
                        className="text-secondary text-truncate c-line-height-1"
                        style={{ minWidth: 0, maxWidth: "280px" }}
                        rel="noreferrer"
                        href={publicUrl}
                        target="_blank"
                        title={publicUrl}
                    >
                        <small>{publicUrl}</small>
                    </a>
                ) : (
                    <small className="text-secondary c-line-height-1">
                        {t("invitation_link_generate_info")}
                    </small>
                )}
                <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                    {buttons()}
                </div>
            </div>
        );
    }

    return (
        <>
            <h3 className="mt-1 mb-2">{t("invitation_public_url")}</h3>

            <div className="d-flex align-items-center justify-content-between position-relative">
                {link}
                <div className="d-flex align-items-center">{buttons()}</div>
            </div>
        </>
    );




    function buttons() {
        return (
            <>
                <CapsuleButton
                    size="SMALL"
                    onClick={handleCopyToClipboard}
                    icon={Icons.copy}
                    tooltip={t('global_copy')}
                    boostedToolTip
                />
                <div className="ml-2"></div>
            </>
        );
    }
}
